import { Component, ElementRef, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, Renderer2, } from "@angular/core";
import { exposeComponentInDebugMode } from "../misc/expose-component-in-debug-mode.decorator";
import { NG_VALUE_ACCESSOR, SelectControlValueAccessor } from "@angular/forms";
import { Subscription } from "rxjs/Subscription";
import "./tree-select.scss";
import { createEvent } from "../misc/event.polyfill";
import { TARGET_SYSTEM } from "../helpers/app-constants";
import { AppSettingsService } from "../app-settings/app-settings.service";


export function makeTreeSelectComponentProvider() {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TreeSelectComponent),
    multi: true,
  };
}


@Component({
  selector: "tree-select",
  templateUrl: "./tree-select.template.pug",
  providers: [makeTreeSelectComponentProvider()],
})
@exposeComponentInDebugMode({ multi: true })
export class TreeSelectComponent extends SelectControlValueAccessor implements OnInit, OnDestroy {
  //private _countryId: string;
  private _value: string;
  private subscription: Subscription;
  //filteredRegions: RegionModel[] = [];
  //regions: RegionsByCountryModel = {};
  private valuesList;
  showOptions = false;
  selectedtext;

  @Output("onChange")
  public onChangeEmitter: any = new EventEmitter();

  @Input()
  blank: boolean;

  @Input()
  inputId: string;

  @Input()
  inputName: string;

  @Input()
  disabled: boolean;

  @Input()
  POR190: boolean;

  @Input()
  error: Error;

  targetSystems = TARGET_SYSTEM;
  POR373_02_flag: boolean;
  POR624_flag: boolean;
  POR624_migration_flag: boolean;
  POR709_TMC: boolean;

  private emitOnChange(obj: string, oldObj: string): void {
    const event = createEvent("change");
    event["value"] = obj;
    event["oldValue"] = oldObj;
    this.onChangeEmitter.emit(event);
  }

  onChange = (_) => { }; // eslint-disable-line
  onTouched = () => { };

  get value(): string {
    return this._value;
  }

  set value(obj: string) {
    const oldObj = this._value;
    this._value = obj;

    this.onChange(obj);
    this.emitOnChange(obj, oldObj);
  }

  writeValue(obj: string) {
    this._value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private appSettingsService: AppSettingsService,
  ) {
    super(renderer, elementRef);
  }

  async ngOnInit() {
    const featurePermissions = await this.appSettingsService.getFeaturePermissionsList(["enableDaas", "POR624_TMC", "POR624", "enableMigration", "POR373-2_TMC", "POR373-2", "POR709_TMC"]);

    this.POR624_flag = await featurePermissions["enableDaas"] && (await featurePermissions["POR624_TMC"] ||
      await featurePermissions["POR624"]);
    this.POR624_migration_flag = await featurePermissions["enableMigration"] && (await featurePermissions["POR624_TMC"] ||
      await featurePermissions["POR624"]);
    this.POR373_02_flag = (await featurePermissions["POR373-2_TMC"] ||
      await featurePermissions["POR373-2"]);
    this.POR709_TMC = await featurePermissions["POR709_TMC"];


  }

  selectTargetSystem(val, txt) {
    this.value = val;
    this.selectedtext = txt;
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }
}
